import React from 'react';
import "./j2vStyle.css";
import "./j2vbootstrap-icons.css";
import j2v from "./images/j2vlogo.png";
import mainHeroImage from "./images/Card1.webp";
import chefImage from "./images/Card2.webp";
import casualWearImage from "./images/Card3.webp";
import quality from "./images/quality-icon.webp";
import waranty from "./images/warrenty-icon.webp";
import shipping from "./images/shipping-icon.webp";
import Support from "./images/suport-icon.webp";
import icon from "./images/Icon.png";
import icon1 from "./images/Icon (1).png";
import outfit from "./images/outfit.png";

const J2vHome = () => { 
 return (
    <div className="">
      {/* Top Bar */}
      {/* Using Bootstrap classes for background, text color, padding, rounded corners, and shadow */}
      <div className="bg-primary text-white py-2 px-4 rounded-bottom shadow menubar">
        <div className="container-fluid d-flex flex-column flex-md-row justify-content-between align-items-center ">
          {/* Left section: Talk to Uniform Consultant */}
          <div className="mb-2 mb-md-0 fs-6"> {/* fs-6 for smaller font size */}
            <span className="text-white py-1 px-2 rounded-pill">Talk to Uniform Consultant</span>
          </div>

          {/* Right section: Navigation links */}
          <nav className="d-flex gap-5 fs-6"> {/* gap-3 for spacing between links */}
            <a href="#" className="text-white text-decoration-none hover-underline">Tracking Package</a>
            <a href="#" className="text-white text-decoration-none hover-underline">FAQ</a>
            <a href="#" className="text-white text-decoration-none hover-underline">About Us</a>
            <a href="#" className="text-white text-decoration-none hover-underline">Contact Us</a>
          </nav>
        </div>
      </div>

      {/* Main Navigation Bar (Placeholder) */}
      {/* Using Bootstrap classes for background, shadow, padding, and rounded corners */}
<nav class="navbar navbar-expand-lg bg-white">
  <div class="container-fluid d-flex align-items-center justify-content-between">


    <div class="d-flex align-items-center">
      <img src={j2v} alt="Logo" class="logo-img"/>
    </div>


    <div class="d-flex align-items-center flex-grow-1 ">
   
 <div class="custom-search">
  <input type="text" placeholder="Search here" />
  <i class="bi bi-search"></i>
</div>

  
      <ul class="navbar-nav flex-row align-items-center gap-4 ms-4">
        <li class="nav-item">
          <a class="nav-link d-flex align-items-center" href="#">
            All Category <i class="bi bi-caret-down-fill ms-1 small"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Corporate</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Industrial</a>
        </li>
      </ul>
    </div>


    <div class="d-flex align-items-center gap-3 nav-icons">
      <a href="#"><i class="bi bi-heart"></i></a>
      <a href="#"><i class="bi bi-person"></i></a>
      <a href="#"><i class="bi bi-cart"></i></a>
    </div>
  </div>
</nav>


    <section className="hero-categories py-5">
      <div className="container-fluid hero">
        <div className="row g-4"> {/* g-4 adds gutter space between columns */}

          {/* Left - Main Hero Section */}
          <div className="col-12 col-lg-8"> {/* Takes full width on small screens, 8 columns on large */}
            <div className="main-hero-card card position-relative overflow-hidden">
              <img src={mainHeroImage} alt="Industrial Uniforms" className="main-hero-bg-img img-fluid" />
              <div className="main-hero-content text-center text-md-start">
                <h2 className="indust_uniforms">Industrial Uniforms<br />Outfit wear</h2>
                <p className="collectiontxt">100+ Collections for your outfit inspirations in this summer</p>
                <button className="btn btn-dark btn-lg px-4 py-2 rounded-pill">VIEW COLLECTIONS</button>
              </div>
            </div>
          </div>

          {/* Right - Two Smaller Category Sections */}
          <div className="col-12 col-lg-4 d-flex flex-column gap-4"> {/* Takes full width on small, 4 columns on large */}

            {/* Premium Chef's Wear */}
            <div className="category-card card rounded-4 shadow-sm h-50 position-relative overflow-hidden">
              <img src={chefImage} alt="Premium Chef's wear" className="category-bg-img img-fluid" />
              <div className="category-content p-4">
                <h3 className="cheftitle">Premium<br />Chef's wear</h3>
              </div>
            </div>

            {/* Casual Comfort Wears */}
            <div className="category-card card rounded-4 shadow-sm h-50 position-relative overflow-hidden">
              <img src={casualWearImage} alt="Casual Comfort Wears" className="category-bg-img img-fluid" />
              <div className="category-content p-4">
                <h3 className="cheftitle">Casual<br />comfort wears</h3>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>




 <div className="container-fluid my-5">
  <div className="row g-4 align-items-stretch">
    {/* Casual Inspirations */}
    <div className="col-lg-3 d-flex align-items-center justify-content-center">
      <div className="p-4">
        <h2>Casual Inspirations</h2>
        <p className="text-muted">
          Our favorite combinations for casual outfit that can inspire you to apply on your daily activity.
        </p>
        <button className="btn btn-outline-dark rounded-pill px-4">
          BROWSE PRODUCTS
        </button>
      </div>
    </div>

    {/* Professional Security Wears */}
    <div className="col-lg-5">
      <div className="securtiy-image h-100 position-relative">
        <h3 className="securitytxt">Professional <br /> Security wears</h3>
      </div>
    </div>

    {/* Hospital Wears */}
    <div className="col-lg-4">
      <div className="wear-image h-100 position-relative">
        <h3 className="weartxt">Hospital wear’s</h3>
        <p className="wear-desc text-muted">
          Our favorite combinations for casual outfit that can inspire you to apply on your daily activity.
        </p>
      </div>
    </div>
  </div>
</div>




{/* <!-- Feature Section --> */}
<div class="container-fluid my-5 featuresection">
  <div class="row g-4 text-center text-md-start">
    {/* <!-- Card 1 --> */}
    <div class="col-12 col-sm-6 col-lg-3">
      <div class="feature-card p-4 d-flex align-items-center gap-3 rounded-4 ">
        <img src={quality} alt="High Quality" width="51" height="50"/>
        <div>
          <h6 class="featuretitles">High Quality</h6>
          <p class="featurepara">crafted from top materials</p>
        </div>
      </div>
    </div>

    {/* <!-- Card 2 --> */}
    <div class="col-12 col-sm-6 col-lg-3">
      <div class="feature-card p-4 d-flex align-items-center gap-3 rounded-4 ">
        <img src={waranty} alt="Warranty Protection" width="38" height="50"/>
        <div>
          <h6 class="featuretitles">Warranty Protection</h6>
          <p class="featurepara">Over 2 years</p>
        </div>
      </div>
    </div>

    {/* <!-- Card 3 --> */}
    <div class="col-12 col-sm-6 col-lg-3">
      <div class="feature-card p-4 d-flex align-items-center gap-3 rounded-4 ">
        <img src={shipping} alt="Free Shipping" width="46" height="50"/>
        <div>
          <h6 class="featuretitles">Free Shipping</h6>
          <p class="featurepara">Order over 150 $</p>
        </div>
      </div>
    </div>
{/* 
    <!-- Card 4 --> */}
    <div class="col-12 col-sm-6 col-lg-3">
      <div class="feature-card p-4 d-flex align-items-center gap-3 rounded-4 ">
        <img src={Support} alt="24 / 7 Support" width="50" height="50"/>
        <div>
          <h6 class="featuretitles">24 / 7 Support</h6>
          <p class="featurepara">Dedicated support</p>
        </div>
      </div>
    </div>
  </div>
</div>



{/* <!-- Hero Section --> */}
<section class="container-fluid my-5">
  <div class="hero-banner d-flex flex-column flex-lg-row align-items-center justify-content-between p-5 rounded-4 text-white">
    
    {/* <!-- Left Text --> */}
    <div class="col-lg-6 mb-4 mb-lg-0">
      <p class="text-light opacity-75 mb-2">Lorem ipsum</p>
      <h1 class="display-4 fw-bold lh-sm">
        Publishing industries for <br />
        previewing layouts.
      </h1>
      <p class="mt-3 text-light opacity-75">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
        Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
      </p>
      <button class="btn btn-light text-dark rounded-pill px-4 mt-4 fw-semibold">
        BROWSE PRODUCTS
      </button>
    </div>

    {/* <!-- Right Image --> */}
    <div class="col-lg-5 text-center">
      <img src="images/hero-woman.png" class="img-fluid rounded-4" alt="Woman" />
    </div>

  </div>
</section>





{/* <!-- Love To Shop Section --> */}
<section class="py-5 bg-light text-center">
  <div class="whyConatiner">
    <h2 class="shoptxt">Why you’ll love to shop on our <br></br> website</h2>
    
    <div class="row g-4 text-start justify-content-center shopsection">
      
      {/* <!-- Card 1 --> */}
      <div class="col-12 col-md-6 col-lg-4">
        <div class="text-left">
          <div class="icon-circle mb-3 mx-auto">
            <img src={icon}/>
          </div>
          <h4 class="fw-semibold">Take care with love</h4>
          <p class="text-muted">We take care your package with full of attention and of course full of love. We want to make sure you’ll receive your package like you receive your birthday gift.</p>
        </div>
      </div>

      {/* <!-- Card 2 --> */}
      <div class="col-12 col-md-6 col-lg-4">
        <div class="text-left">
          <div class="icon-circle mb-3 mx-auto">
            <img src={icon1}/>
          </div>
          <h4 class="fw-semibold">Friendly Customer Service</h4>
          <p class="text-muted">You do not need to worry when you want to check your package. We will always answer whatever your questions. Just click on the chat icon and we will talk.</p>
        </div>
      </div>

      {/* <!-- Card 3 --> */}
      <div class="col-12 col-md-6 col-lg-4">
        <div class="text-left">
          <div class="icon-circle mb-3 mx-auto">
            <img src={icon}/>
          </div>
          <h4 class="fw-semibold">Refund Process</h4>
          <p class="text-muted">Refund is a such bad experience and we don’t want that thing happen to you. But when it’s happen we will make sure you will through smooth and friendly process.</p>
        </div>
      </div>

    </div>
  </div>
</section>



<section class="outfitcontainer my-5">
  <div class="row align-items-center gx-xxl-5 gx-lg-5 gx-md-4 gx-3 g-4">

    <div class="col-lg-6">
      <img src={outfit} class="img-fluid w-100 rounded-4 outfit-image" alt="Outfit Collection"/>
    </div>


    <div class="col-lg-6">
      <h2 class="combinetxt">
        How to combine your <br></br>
        daily outfit to looks <br></br>
        fresh and cool.<br></br>
      </h2>
      <p class="text-muted mt-4 mb-4">
        Maybe you don’t need to buy new clothes to have nice, cool, fresh <br></br> looking outfit everyday.
        Maybe what you need is to combine your <br></br> clothes collections. Mix and match is the key.
      </p>
      <a href="#" class="btn btn-outline-dark rounded-pill px-4 py-2">VIEW CATEGORY</a>
    </div>
  </div>
</section>



<footer class="bg-dark text-white pt-5 pb-4">
  <div class="container text-md-left">
    <div class="row text-md-left">

  
      <div class="col-md-3 col-lg-3 col-xl-3 mx-auto mt-3">
        <h5 class="text-uppercase mb-4 font-weight-bold">J2 Vestures</h5>
        <p>We provide high-quality uniforms that suit all your industrial, corporate, and casual needs with style and comfort.</p>
      </div>

   
      <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3">
        <h5 class="text-uppercase mb-4 font-weight-bold">Quick Links</h5>
        <p><a href="#" class="text-white text-decoration-none">Home</a></p>
        <p><a href="#" class="text-white text-decoration-none">Shop</a></p>
        <p><a href="#" class="text-white text-decoration-none">About Us</a></p>
        <p><a href="#" class="text-white text-decoration-none">Contact</a></p>
      </div>

      
      <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mt-3">
        <h5 class="text-uppercase mb-4 font-weight-bold">Support</h5>
        <p><a href="#" class="text-white text-decoration-none">FAQ</a></p>
        <p><a href="#" class="text-white text-decoration-none">Tracking</a></p>
        <p><a href="#" class="text-white text-decoration-none">Returns</a></p>
        <p><a href="#" class="text-white text-decoration-none">Privacy Policy</a></p>
      </div>

      <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
        <h5 class="text-uppercase mb-4 font-weight-bold">Contact</h5>
        <p><i class="bi bi-house-door-fill me-2"></i> Chennai, India</p>
        <p><i class="bi bi-envelope-fill me-2"></i> support@j2v.com</p>
        <p><i class="bi bi-telephone-fill me-2"></i> +91 98765 43210</p>
      </div>

    </div>


    <hr class="my-4 text-white" />


    <div class="row align-items-center">
      <div class="col-md-7 col-lg-8">
        <p class="text-white">© 2025 J2 Vestures. All Rights Reserved.</p>
      </div>


      <div class="col-md-5 col-lg-4">
        <div class="text-center text-md-end">
          <a href="#" class="text-white me-3"><i class="bi bi-facebook"></i></a>
          <a href="#" class="text-white me-3"><i class="bi bi-twitter"></i></a>
          <a href="#" class="text-white me-3"><i class="bi bi-instagram"></i></a>
          <a href="#" class="text-white"><i class="bi bi-linkedin"></i></a>
        </div>
      </div>
    </div>

  </div>
</footer>






    </div>
  );
}

export default J2vHome;
